import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from '../../../config/config'; // Importing development configuration

/**
 * Class representing the FilterPagoNotaRetiroView.
 * @extends JetView
 */
export default class FilterPagoNotaRetiroView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration
        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Text input for Cedula
                            name: 'Cedula',
                            id: 'IdNota',
                            label: "<span class='icon-id'></span>" + _('Cedula del cliente'),
                            labelPosition: 'top',
                            placeholder: _('Cedula del cliente'),
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                            attributes: {
                                autocomplete: 'new-password', // Prevents autocomplete
                            },
                            hidden: devConfig.getPartnerSelected() != '8', // Conditional visibility
                        },
                        {
                            view: 'text', // Text input for Id Nota de Retiro
                            name: 'IdNota',
                            type: 'number',
                            id: 'IdNota',
                            label: "<span class='icon-id'></span>" + _('Id Nota de Retiro'),
                            labelPosition: 'top',
                            placeholder: _('Id Nota de Retiro'),
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                            attributes: {
                                autocomplete: 'new-password', // Prevents autocomplete
                            },
                        },
                        {
                            view: 'text', // Password input for Clave
                            name: 'Clave',
                            type: 'password',
                            id: 'Clave',
                            label: "<span class='icon-key'></span>" + _('Clave'),
                            labelPosition: 'top',
                            placeholder: _('Clave'),
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                            attributes: {
                                autocomplete: 'new-password', // Prevents autocomplete
                            },
                        },
                        { id: 'grav5', gravity: 1 }, // Gravity element for layout
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            height: screen == 'small' ? 180 : 0, // Conditional height based on screen size
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section containing inputs
                },
            ],
        };
        const datos = {
            // Sample data object
            ValorPagar: '1.2426',
            ValorApostado: '1.00',
            PremioProyectado: '1.24',
            Estado: 'Ganador',
            Ganador: 'Si',
        };
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav4', gravity: 4 }, // Gravity element for layout
                        {
                            view: 'button', // Button to clear the form
                            value: _('Limpiar'),
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clears the form
                                $$('FilterPagoNotaRetiro').clearValidation(); // Clears validation
                                $$('buttonPagarNotaRetiro').hide(); // Hides payment button
                            },
                        },
                        {
                            view: 'button', // Button to consult data
                            value: _('Consultar'),
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            hotkey: 'enter', // Enter key triggers this button
                            click: () => {
                                const vthis = this; // Reference to the current instance
                                $$('buttonPagarNotaRetiro').hide(); // Hides payment button
                                if (this.getRoot().validate()) {
                                    // Validates the form
                                    const filterdata = this.getRoot().getValues(); // Gets form values
                                    this.app.callEvent(
                                        'pagoNotaRetiro:filter',
                                        [filterdata], // Calls event with filter data
                                    );
                                    let filter = ''; // Initializes filter string
                                    if (devConfig.getPartnerSelected() == '8') {
                                        filter =
                                            'IdNota=' +
                                            filterdata.IdNota +
                                            '&Clave=' +
                                            filterdata.Clave +
                                            '&Cedula=' +
                                            filterdata.Cedula; // Constructs filter for partner 8
                                    } else {
                                        filter = 'IdNota=' + filterdata.IdNota + '&Clave=' + filterdata.Clave; // Constructs filter for other partners
                                    }
                                    webix
                                        .ajax()
                                        .get(devConfig.geturlApi() + 'UserManagement/GetPagoNotaRetiro', filter, {
                                            error: function (text, data, XmlHttpRequest) {
                                                webix.message('Error! '); // Error message on failure
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                text = JSON.parse(text); // Parses response text
                                                if (text.HasError) {
                                                    if (text.CodeError != undefined) {
                                                        webix.message({
                                                            title: "¡Error!",
                                                            type: "alert-error",
                                                            text: _("ERROR" + text.CodeError.toString())
                                                        });
                                                    } else {
                                                        webix.message({
                                                            title: "¡Error!",
                                                            type: "alert-error",
                                                            text: _(text.AlertMessage)
                                                        });
                                                    }
                                                } else if (text.data[0].State == 'E') {
                                                    webix.message({
                                                        title: '¡Error!',
                                                        type: 'alert-error',
                                                        text: _(
                                                            text.AlertMessage, // Displays alert message if state is 'E'
                                                        ),
                                                    });
                                                } else {
                                                    $$('FilterPagoNotaRetiro').hide(); // Hides filter form
                                                    $$('formPagoNotaRetiro').show(); // Shows payment form
                                                    $$('back-button').show(); // Shows back button
                                                    vthis.app.callEvent(
                                                        'pagoNotaRetiro:data',
                                                        [text.data[0]], // Calls event with retrieved data
                                                    );
                                                    if (text.data[0].State == 'I') {
                                                        $$('templatemMessage').setHTML(
                                                            '<div style="text-align: center;">' +
                                                                _(
                                                                    'Nota de retiro pagada', // Displays message for paid note
                                                                ) +
                                                                '</div>',
                                                        );
                                                    } else {
                                                        $$('templatemMessage').hide(); // Hides message template
                                                    }
                                                    if (text.data[0].State == 'A') {
                                                        $$('buttonPagarNotaRetiro').show(); // Shows payment button if state is 'A'
                                                    }
                                                }
                                            },
                                        });
                                }
                            },
                        },
                    ],
                },
            ],
        };
        return {
            view: 'form', // Main form view
            id: 'FilterPagoNotaRetiro',
            rows: [upper_section, buttons], // Combines upper section and buttons
            elementsConfig: {
                on: {
                    onChange: function (newv, oldv) {
                        this.validate(); // Validates on change
                        $$('IdNota').define('inputHeight', 38); // Sets input height
                        $$('IdNota').refresh(); // Refreshes input
                        $$('Clave').define('inputHeight', 38); // Sets input height
                        $$('Clave').refresh(); // Refreshes input
                    },
                },
            },
        };
    }

    /**
     * Initializes the view.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav4').hide(); // Hides element for small screens
                $$('grav5').hide(); // Hides element for small screens
            }
        });
    }
}

// FILE DOCUMENTED
